import { Observable } from 'rxjs';
import { Order } from '@features/sales/domain/entities/order/order.entity';

export abstract class OrderRepository {
  abstract create(order: Order): Observable<Order>;
}
